import React, { useState } from 'react';
import {
  Box,
  ToggleButton,
  Popover,
  Stack,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useDispatch } from 'react-redux';
import { setPhysics, clearSelection, requestFit } from '../../features/networkSlice';
import { setNetwork } from '../../features/networkUndoSlice';
import { normalizeModel } from '../../lib/model';
import snowshoe from '../../data/snowshoe.json';

export default function Info() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleLoadExample = () => {
    dispatch(setPhysics(false));
    dispatch(clearSelection());
    dispatch(setNetwork(normalizeModel(snowshoe)));
    dispatch(requestFit());
    setAnchorEl(null);
  };

  return (
    <>
      <ToggleButton
        size="small"
        value="info"
        selected={open}
        title="Info"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <InfoOutlinedIcon fontSize="small" />
      </ToggleButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ p: 2, width: 340 }}>
          <Stack spacing={2}>
            <Typography variant="subtitle2">Getting started</Typography>
            <Typography variant="body2">
              Create nodes for system components and connect them with signed links.
              Use the toolbar to add nodes, create positive or negative links, and edit labels.
              The sidebar holds the model details and the tables of nodes and links.
            </Typography>
            <Divider />
            <Typography variant="subtitle2">What is a signed digraph?</Typography>
            <Typography variant="body2">
              A signed digraph (or signed directed graph) shows how components influence each other.
              A positive link means a positive change in one node produces a positive change in the other.
              A negative link means a positive change in one node produces a negative change in the other.
            </Typography>
            <Button variant="outlined" size="small" onClick={handleLoadExample}>
              LOAD SNOWSHOE HARE EXAMPLE
            </Button>
            <Divider />
            <Typography variant="subtitle2">Mouse</Typography>
            <Box component="ul" sx={{ m: 0, pl: 2, typography: 'body2' }}>
              <li>Drag the canvas to pan, scroll to zoom</li>
              <li>Drag a node to move it</li>
              <li>With a link tool, drag from one node to another (or itself)</li>
              <li>Double-click or right-click a node or link to edit it</li>
            </Box>
            <Typography variant="subtitle2">Keyboard shortcuts</Typography>
            <Box component="ul" sx={{ m: 0, pl: 2, typography: 'body2' }}>
              <li>n: new node</li>
              <li>+/=: positive link</li>
              <li>-: negative link</li>
              <li>d: delete tool</li>
              <li>s: select tool</li>
              <li>f: fit to view</li>
              <li>Delete: remove selected nodes/links</li>
              <li>Esc: clear selection</li>
              <li>Ctrl+Z: undo</li>
              <li>Ctrl+Y / Ctrl+Shift+Z: redo</li>
              <li>Alt+ArrowUp/Down: move row (nodes/links table)</li>
            </Box>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
